import { coreFetch, type Nullable } from '@libs/core';
import type { DoorDashAPIBody, DoorDashAPIResponseEstimate } from '../types';
import { DOOR_DASH_API_URL, DOOR_DASH_API_ESTIMATE } from '../constants';

type DeliveryValidationProps = (
    token: string,
    body: DoorDashAPIBody
) => Promise<Nullable<DoorDashAPIResponseEstimate>>;

export const deliveryEstimate: DeliveryValidationProps = async (token, body) =>
    await coreFetch<Nullable<DoorDashAPIResponseEstimate>>(
        `${DOOR_DASH_API_URL}${DOOR_DASH_API_ESTIMATE}`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(body),
        }
    );
